module.exports = {"CurrentLanguage":"es"}


//////////////////
// WEBPACK FOOTER
// ./src/languages/es.json
// module id = tZBW
// module chunks = 0